
/* System defined core library */
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { SchedulingApiService } from '../../services/scheduling-api.service';
import { UtilityService } from '../../../../shared/services/utility.service';
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';

/* User defined enums/constants */
import { ComponentType } from '../../../../shared/enums/scheduling.enum';
import { TranslateService } from '@ngx-translate/core';


/* User defined models */
import { Timezone } from '../../../../shared/models/scheduling/timezone.model';

@Component({
  selector: 'app-timezone-selector',
  templateUrl: './timezone-selector.component.html'
})
/** timezone-selector component*/
export class TimezoneSelectorComponent implements OnInit, OnChanges {

  /* User defined private/public variables  */
  public timezones: Timezone[] = [];
  public selectedTimezoneExist: boolean = false;
  public errorMessage: string = '';
  public timezoneFrm: FormGroup;
  public selectedTimezone: Timezone;

  /* Input-OutPut parameters decalartions */

  @Input() public selectedTimezoneSystemName: string;
  @Input() public tzComponent: boolean = true;
  @Output() getSelectedTimezone: EventEmitter<Timezone> = new EventEmitter();

  /* Service subscriptions */
  exam$: Subscription;
  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private selectedExamDetailService: SelectedExamDetailService,
    private schedulingApiService: SchedulingApiService,
    private fb: FormBuilder,
    private router: Router,
    private utilityService: UtilityService,
    private translate: TranslateService
  ) {

  }

  ngOnInit() {
    sessionStorage.setItem('previousUrl', window.location.pathname);

    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.TimezoneSelectorComponent)) return;

    this.translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = this.selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        this.translate.use(languageCode);
      });


    this.timezoneFrm = this.fb.group({
      'selectTimezone': new FormControl('', Validators.required),
    });
    this.getTimezones();
  }

  getTimezones() {
    this.schedulingApiService.getTimezones(1).subscribe(
      timezones => {
        this.timezones = timezones;
        this.selectedTimezone = this.timezones.filter(tz => tz.systemName === this.selectedTimezoneSystemName)[0];
        this.getSelectedTimezone.emit(this.selectedTimezone);
      },
      error => this.errorMessage = <any>error
    );

  }

  /* Set selected time zone in shared service */
  changeTimezone(timezone: Timezone): void {
    this.selectedTimezone = timezone;
    this.getSelectedTimezone.emit(this.selectedTimezone);
  }


  /*
  * detect if selectedTimezone is to null by parent and retrieve programs again as per new program
  * @param changes
  */
  ngOnChanges(changes: SimpleChanges) {
    if (
      ((changes && changes.selectedTimezone && !changes.selectedTimezone.currentValue)
        || (changes && !changes.selectedTimezone))
      && (!changes.selectedTimezoneSystemName || (changes.selectedTimezoneSystemName && !changes.selectedTimezoneSystemName.currentValue))
    ) {
      this.selectedTimezone = null;
    }

    if (this.timezones === null || this.timezones === undefined || (this.timezones && !this.timezones.length)) {
      this.getTimezones();
    }

  }
}